import Api from '@/api'

export default {
  namespaced: true,
  state: {
    data: null,
    loaded: false
  },
  actions: {
    // TODO Synch all calls
    load ({state, commit}, params) {
      commit('setLoaded', false)
      return Api.getProjects().then(res => {
        commit('setData', res)
        commit('setLoaded', true)
        return res
      })
    }
  },
  mutations: {
    setData (state, value) {
      state.data = value
    },
    setLoaded(state, val) {
      state.loaded = val
    },
    resetData (state) {
      state.data = null
      state.loaded = false
    },
  }
}
